import {Component, Injector, Input, OnInit} from "@angular/core";
import {AbstractControl, FormControl, FormGroup} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute, Router} from "@angular/router";
import {DokladovaRadaDto} from "src/app/dokladova-rada-data/models/DokladovaRadaDtos";
import {ButtonInvoke} from "src/app/shared/panel-buttons/panel-buttons.component";
import {DialogService} from "src/app/shared/dialog/dialog.service";
import {DokladovaRadaDataService} from "src/app/dokladova-rada-data/dokladova-rada-data.service";
import {of} from "rxjs";
import {Field} from "src/app/shared/detail/detail.service";
import {UcetniJednotkaDataService} from "src/app/ucetni-jednotka-data/ucetni-jednotka-data.service";
import {UcetniObdobiDataService} from "src/app/ucetni-obdobi-data/ucetni-obdobi-data.service";
import {DialogComunicationService} from "src/app/shared/dialog/dialog-comunication.service";
import {TableDialogComponent} from "../../shared/cml-forms/show-table.dialog/table-dialog.component";
import {ShowType} from "../../shared/dialog/snack-bar/snack-bar/snack-bar.component";
import {DokladovaRadaFormDialogService} from "../dokladova-rada-form-dialog-service";
import {MapperDefaultValues, MapperKeys} from "../../shared/crud/abstractions/base-crud";

const COLUMNS: Field[] = [
  { name: "kod", type: "string", title: "Kód", maxLength: 4, minLength: 2, required: true },
  { name: "nazev", type: "string", title: "Název", maxLength: 255, minLength: 1, required: true },
  { name: "odCisla", type: "number", title: "Od čísla", required: true },
  { name: "doCisla", type: "number", title: "Do Čísla", required: true },
  { name: "posledniCislo", type: "number", title: "Poslední číslo", required: true },
  { name: "delkaCisla", type: "number", title: "Délka čísla", required: true },
  { name: "celkovaMaska", type: "string", title: "Celková maska", maxLength: 20, minLength: 1, required: true }
];

const EDIT_COLUMNS: Field[] = [
  { name: "nazev", type: "string", title: "Název" },
  { name: "odCisla", type: "number", title: "Od čísla" },
  { name: "doCisla", type: "number", title: "Do Čísla" },
  { name: "posledniCislo", type: "number", title: "Poslední číslo" },
  { name: "delkaCisla", type: "number", title: "Délka čísla" },
  { name: "celkovaMaska", type: "string", title: "Celková maska" }
];

const COPY_COLUMNS: Field[] = [
  { name: "kodUj", type: "autocomplete", title: "Účetní jednotka" },
  { name: "kodUo", type: "extended_autocomplete", title: "Kód účetního období" }
];

@Component({
    selector: 'cml-dokladova-rada-tabulka',
    templateUrl: './dokladova-rada-tabulka.component.html',
    styleUrls: ['./dokladova-rada-tabulka.component.scss'],
    standalone: false
})
export class DokladovaRadaTabulkaComponent implements OnInit {

  dataSource: Array<DokladovaRadaDto> = [];
  dataService: DokladovaRadaDataService | any;
  buttons: ButtonInvoke[] = [];
  formGroup: FormGroup[] = [];

  kodUo: string = "";
  entityId: string = "";
  isEdit: boolean = false;
  columns = COLUMNS;
  editColumns = EDIT_COLUMNS;
  copyColumns = COPY_COLUMNS;

  @Input() compareKodUj: string = "";
  @Input() compareKodUo: string = "";
  @Input() isComparation: boolean = false;

  constructor(private route: ActivatedRoute, private injector: Injector, private router: Router, private dialog: DialogService,
    private ucetniJednotkaDataService: UcetniJednotkaDataService,
    private UOdataService: UcetniObdobiDataService,
    private dialogComunicationService: DialogComunicationService,
    private matDialog: MatDialog) {

    let routeConfig = route.routeConfig;
    if (routeConfig && routeConfig.data) {
      this.dataService = this.injector.get(routeConfig.data['dataService']);
    }
  }

  async ngOnInit(): Promise<void> {
    if (!this.compareKodUj && !this.compareKodUo) {
      this.entityId = this.route.snapshot.paramMap.get('id')!;
      this.kodUo = this.route.snapshot.paramMap.get('kod')!;
    } else {
      this.entityId = this.compareKodUj;
      this.kodUo = this.compareKodUo;
    }
    await this.init();
  }

  async init() {
    await this.getData();
    this.formGroup = [];
    this.dataSource.forEach((item: any) => {
      const group: { [key: string]: AbstractControl } = {};
      this.columns.forEach(val => {
        let fc = new FormControl(item[val.name])
        group[val.name] = fc;
      });
      this.formGroup.push(new FormGroup(group));
    });
  }

  async getData() {
    const mapped = this.dataService.setMapper([{key: MapperKeys.KodUj, value: this.entityId},{key:MapperKeys.KodUo, value:this.kodUo}])
    this.dataSource = await this.dataService.getAll(mapped);
  }

  navigateBack() {
    this.router.navigateByUrl(this.router.url.replace("/dokladova-rada/" + this.kodUo, ''));
  }

  async save() {
    for (const group of this.formGroup) {
      if (group.touched) {
        const kod = group.value["kod"];
        const json = JSON.parse(this.createJsonString(group, this.getAttributes(this.editColumns), this.editColumns));
        try {
          const mapped = this.dataService.setMapper([{key: MapperKeys.KodUj, value: this.entityId}, {key: MapperKeys.KodUo, value: this.kodUo},{key: MapperKeys.Kod, value: kod}])
          await this.dataService.edit(mapped, json);
          this.isEdit = false;
        } catch (e) {
          await this.dialog.handleError(e);
        }
      }
    }
    this.confirmSucces("Vaše změny byly uloženy.");
  }

  getAttributes(columns: any) {
    return columns.map((item: any) => {
      return item['name'];
    });
  }

  createJsonString(group: any, nazvy: Array<string>, columns: any) {
    return nazvy.reduce((prev, current) =>
      prev + "\"" + current + "\"" + ": " +
      `${columns.find((item: any) => item.name === current)!.type == "string" ? "\"" + group.value[current] + "\"" : group.value[current]}`
      + ", ", "{").slice(0, -2) + "}";
  }

  edit() {
    this.isEdit = true;
    return true;
  }

  stopEdit() {
    this.isEdit = false;
    return false;
  }

  async new() {
    const resForm = await this.dialog.form({title: "Nová dokladová řada", detail:this.columns});
    if (resForm) {
      const json = JSON.parse(this.createJsonString(resForm, this.getAttributes(this.columns), this.columns));
      await this.init();
      try {
        const mapped = this.dataService.setMapper([{key: MapperKeys.KodUj, value: this.entityId}, {key: MapperKeys.KodUo, value: this.kodUo}])
        await this.dataService.create(mapped, json, undefined);
        this.confirmSucces("Nová řada úspěšně přidána");
        await this.init()
      } catch (e) {
        await this.dialog.handleError(e);
      }
    }
  }

  async delete(i: number) {
    const conf = await this.dialog.confirm({title: "Potvrzení", detail: "Chcete opravdu smazat tuto dokladovou řadu?"});
    if (conf) {
      try {
        const mapped = this.dataService.setMapper([{key: MapperKeys.KodUj, value: this.entityId}, {key: MapperKeys.KodUo, value: this.kodUo},{key: MapperKeys.Kod, value: await this.formGroup[i].value["kod"] }])
        await this.dataService.delete(mapped);
        this.confirmSucces("Dokladová řada byla úspěšně smazána");
        await this.init();
      } catch (e) {
        await this.dialog.handleError(e);
      }
    }
  }

  async copy() {
    await this.addObservable(this.copyColumns);
    const form = await this.dialog.form({title: "Kopírování řady", detail: this.copyColumns, validation: true, component: this as any},DokladovaRadaFormDialogService);
    if (form) {
      const entity = this.fillEntityFromForm(form, this.copyColumns);
      const odKodUj = entity["kodUj"];
      const odKodUo = entity["kodUo"];
      const mapped = this.dataService.setMapper([{key: MapperKeys.KodUj, value: odKodUj}, {key: MapperKeys.KodUo, value: odKodUo}])
      const dataFromCopiedUj = await this.dataService.getAll(mapped);

      //nastaveni posledniho cisla na zacatek
      dataFromCopiedUj.forEach((item: any) =>
      {
        item["posledniCislo"] = item["odCisla"] - 1;
      });

      let dataSource = [...dataFromCopiedUj, ...this.dataSource]
      dataSource.forEach((item:any) => {
        const isInDataFrom = dataFromCopiedUj.some((x:any) => x.kod == item.kod);
        const isInDataTo = this.dataSource.some((x:any) => x.kod == item.kod);
        item.type = isInDataFrom && isInDataTo ? "duplicate" : isInDataTo ? "old-polozka" : "new-polozka";
        if(item.type == "duplicate"){
          item.isStaying = item.kodUj == entity["kodUj"] && item.kodUo == entity["kodUo"] ? true : false;
        }
      });

      dataSource.sort((a, b) => a.kod.localeCompare(b.kod));
      const dialogRef = this.matDialog.open(TableDialogComponent, { data: {
                                                                    title: "Potvzení kopírování dokladové řady",
                                                                    dataSource: dataSource,
                                                                    columns: this.columns,
                                                                    displayedColumns: ['kod', 'nazev', 'odCisla', 'doCisla', 'posledniCislo', 'delkaCisla', 'celkovaMaska'],
                                                                  },
                                                                    panelClass: 'dialog-panel' });
      let res = await dialogRef.afterClosed().toPromise();
      if (!res) return;
      try
      {
        const mapped = this.dataService.setMapper(
          [
            {key: MapperKeys.OdKodUj, value: odKodUj},
            {key: MapperKeys.OdKodUo, value: odKodUo},
            {key: MapperKeys.DoKodUj, value: this.entityId},
            {key: MapperKeys.DoKodUo, value: this.kodUo},
          ]
        )
        await this.dataService.create(mapped, null, "kopirovat");
        this.confirmSucces("Dokladová řada byla úspěšně zkopírována");
        await this.init();
      }
      catch (e)
      {
        await this.dialog.handleError(e);
      }
    }
  }

  async addObservable(columns: Field[]) {
    const mapped = this.dataService.setMapper({key: MapperKeys.MaxResultCount, value: 2000})
    this.ucetniJednotkaDataService.getAll({ params: mapped }).then(x => {
      x.forEach(item => item.displayValue = item.kod + " - " + item.nazev);
      let observableKodField =
        {
        observable: of(x),
        optionName: 'displayValue',
        optionValue: 'kod',
      };
      let field = columns.find(x => x.name === 'kodUj');
      if (field) {
        field.observable = observableKodField;
      }
    });
  }

  fillEntityFromForm(form: FormGroup, columns: Field[]) {
    const formValue = form.value;
    let entity: any = new Object();
    for (let field of columns) {
      if (field.type === 'autocomplete' && field.observable) {
        entity[field.name] = formValue[field.name][field.observable.optionValue];
      } else {
        entity[field.name] = formValue[field.name];
      }
    }
    return entity;
  }

  async doValidation(form: FormGroup, columns: Field[]): Promise<boolean> {
    const entity = this.fillEntityFromForm(form, columns);
    const mapped = this.dataService.setMapper(
      [
        {key: MapperKeys.KodUj, value: entity.kodUj},
        {key: MapperKeys.MaxResultCount, value: MapperDefaultValues.MaxResultCount}
      ])
    const res: any = await this.UOdataService.getAll({params:mapped});
    return res.some((val: any) => val.kod === entity["kodUo"]);
  }

  getErrorMessage() {
    return "Vybraná účetní jednotka s vybraným účetním obdobím neexistuje!";
  }

  confirmSucces(text: string)
  {
    this.dialog.openSnackBar(text, ShowType.Success);
  }

  listenForChange(form: FormGroup) {
    form.controls["kodUj"].valueChanges.subscribe(x => {
      if (typeof x == "object")
      {
        const mapped = this.dataService.setMapper(
          [
            {key: MapperKeys.KodUj, value: x.kod},
            {key: MapperKeys.MaxResultCount, value: MapperDefaultValues.MaxResultCount}
          ])
        let res = this.UOdataService.getAll({params: mapped});
        this.dialogComunicationService.sendResults(res);
      }
    });
  }
}
